<template>
  <div class="background_team">
    <div class="team_index_text">
      <p style="font-size: 24px">Our Team</p>
      <p style="font-size: 20px;margin-bottom: 0">Comprehensive analysis </p>
      <p style="font-size: 20px;margin-bottom: 0">and insights lie</p>
      <p style="font-size: 20px;">at the heart of our investment process.</p>
      <p style="font-size: 20px;"></p>
      <p>————</p>
      <p style="font-size: 12px">Based on years of in-depth assessments of numerous companies</p>
      <p style="font-size: 12px">in different industries,we are willing to provide</p>
      <p style="font-size: 12px">our portfolio companies with great assistance to accelerate</p>
      <p style="font-size: 12px">post-investment performance.SIG is dedicated to helping our</p>
      <p style="font-size: 12px">entrepreneurs build successful companies by providing them </p>
      <p style="font-size: 12px">ith capital, guidance, network and the best resources available.</p>
      <div class="index_down">
        <a-button type="ghost" shape="circle-outline" size="large">
          <template v-slot:icon>
            <DownOutlined>
            </DownOutlined>
          </template>
        </a-button>
      </div>
    </div>
  </div>
</template>

<script>
import {DownOutlined} from '@ant-design/icons-vue'

export default {
  name: "Team_index_en_m",
  components: {
    DownOutlined,
  },
  setup() {
    const next_page = () => {
      document.documentElement.scrollBy({
        top: window.innerHeight * 92 / 100,
        behavior: "smooth",
      })
    }
    return {next_page}
  }
}
</script>

<style scoped>
.team_index_text {
  padding-top: 30vh;
  text-align: center;
}

.background_team {
  background-image: url("../../../assets/background/index_team.jpg");
  height: 100vh;
  background-repeat: no-repeat;
  background-position: center;
  background-size: auto 100%;
  margin: 0;
}


</style>